const POSITIONS = {
  WIDGET: 'WIDGET',
  LISTING: 'LISTING',
}

export default POSITIONS
